import { BaseEntity } from "./base-entity";

export class Patient {
  Id: number;
  FirstName: string;
  LastName: string;
  MiddleName: string;
  Email: string;
  Phone: string;
  Age: number;
  Address: string;
  IsActive: boolean;
  ProfilePictureId: number;
  ProfilePictureThumbId: number;
  Note: string;
  physicianAccountId: number;
  Gender: string;
  Guarantor: string;
  DateOfBirth: Date;
  InsuranceInformation: string;
  PatientIdentifier: string;
  CreatedById: number;
  CreatedDate: Date;
  UpdatedById: number;
  UpdatedDate: Date;
  ModifiedBy: string;
  CreatedBy: string;
  constructor() {
    this.Id = 0;
    this.CreatedById = 0;
    this.CreatedDate = null;
    this.UpdatedById = 0;
    this.UpdatedDate = null;
    this.ModifiedBy = null;
    this.CreatedBy = null;
  }
}
